import * as Yup from "yup"

const step1Schema = Yup.object({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
})

const step2Schema = Yup.object({
  emails: Yup.array(
    Yup.object().shape({
      value: Yup.string().email("Valid email is required").required("Email is required"),
    }),
  ),
  phones: Yup.array(
    Yup.object().shape({
      value: Yup.string().nullable(),
    }),
  ).nullable(),
})

const step3Schema = Yup.object({
  birthdate: Yup.string().required("Birthdate is required"),
  gender: Yup.string().required("Gender is required"),
})

const step4Schema = Yup.object({
  practitioner: Yup.string().required("Practitioner is required"),
  termsAccepted: Yup.boolean().oneOf([true], "You must agree to the terms and conditions"),
})

const onboardingPersonValidationSchema = step1Schema.concat(step2Schema).concat(step3Schema).concat(step4Schema)

const stepSchemas = [step1Schema, step2Schema, step3Schema, step4Schema] as const

const TOTAL_ONBOARDING_STEPS = 4

const validateOnboardingStep = async (step: number, values: unknown) => {
  const schema = stepSchemas[step - 1]
  if (!schema) return {}
  try {
    await schema.validate(values, { abortEarly: false })
    return {}
  } catch (err) {
    if (err instanceof Yup.ValidationError) {
      return err.inner.reduce(
        (acc, issue) => {
          if (issue.path) {
            acc[issue.path] = issue.message
          }
          return acc
        },
        {} as Record<string, string>,
      )
    }
    return {}
  }
}

export {
  onboardingPersonValidationSchema,
  step1Schema,
  step2Schema,
  step3Schema,
  step4Schema,
  stepSchemas,
  TOTAL_ONBOARDING_STEPS,
  validateOnboardingStep,
}
